export const CONFIGURATIONS_PRODUCTION_CHECKLIST_ITEM_MODAL_EVENT =
  'configurations:modals:production:checklist-item';

export const CONFIGURATIONS_PRODUCTION_CHECKLIST_ITEM_MODAL_OPEN = `${CONFIGURATIONS_PRODUCTION_CHECKLIST_ITEM_MODAL_EVENT}:open`;
export const CONFIGURATIONS_PRODUCTION_CHECKLIST_ITEM_MODAL_CLOSE = `${CONFIGURATIONS_PRODUCTION_CHECKLIST_ITEM_MODAL_EVENT}:close`;
